// src/hooks/useWebSocketClient.ts
import { useEffect, useState, useCallback, useRef } from 'react';
import { WebSocketClient, ClientState } from 'renderer/utils'; // 경로에 맞게 조정
export var useWebSocketClient = function (url, handleMessage) {
    var _a = useState(null), client = _a[0], setClient = _a[1];
    var _b = useState(ClientState.READY), status = _b[0], setStatus = _b[1];
    var dataListenerRef = useRef(null);
    var statusListenerRef = useRef(null);
    var addListeners = useCallback(function (wsClient) {
        dataListenerRef.current = function (message) {
            if (handleMessage) {
                handleMessage(message);
            }
        };
        statusListenerRef.current = function (status) {
            setStatus(status);
        };
        wsClient.addListener('data', dataListenerRef.current);
        wsClient.addListener('status', statusListenerRef.current);
    }, [handleMessage]);
    var removeListeners = useCallback(function (wsClient) {
        if (dataListenerRef.current) {
            wsClient.removeListener('data', dataListenerRef.current);
        }
        if (statusListenerRef.current) {
            wsClient.removeListener('status', statusListenerRef.current);
        }
    }, []);
    useEffect(function () {
        // getInstance를 통해 클라이언트 생성
        var wsClient = WebSocketClient.getInstance(url);
        addListeners(wsClient);
        setClient(wsClient);
        // 컴포넌트 언마운트 시 cleanup: 리스너 제거 및 연결 종료
        return function () {
            removeListeners(wsClient);
            wsClient.close();
        };
    }, []);
    var connect = useCallback(function () {
        if (client && client.status !== ClientState.CONNECTED) {
            client.open();
        }
    }, [client]);
    var disconnect = useCallback(function () {
        if (client && client.status === ClientState.CONNECTED) {
            client.close();
        }
    }, [client]);
    var sendMessage = useCallback(function (data) {
        if (client && client.status === ClientState.CONNECTED) {
            client.send(data);
        }
        else {
            console.warn('WebSocket is not connected');
        }
    }, [client]);
    return { client: client, status: status, connect: connect, disconnect: disconnect, sendMessage: sendMessage };
};
